import { render, staticRenderFns } from "./_prematch.vue?vue&type=template&id=e3037b04&lang=pug&"
import script from "./_prematch.vue?vue&type=script&lang=js&"
export * from "./_prematch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports